interface options {
  value: string | number;
  label: string;
}

interface ContractHistoryDTO {
  userFullName?: string | null;
  updatedAt?: string;
  action?: string | null;
}

interface IncreaseDTO {
  id: number;
  amount: number;
  startDate: string;
  userId?: string | null;
}

interface BonusDTO {
  id: number;
  amount: number;
  title?: string | null;
  comment?: string | null;
  startDate: string;
  type: 'year' | 'month' | 'week' | 'day' | 'hour' | 'once';
  isActived: boolean;
  userId?: string | null;
}

interface SalaryDTO {
  id?: number | null;
  amount: number;
  type: 'year' | 'month' | 'week' | 'day' | 'hour' | 'once';
  contractId?: number | null;
  userId?: string | null;
  createdDate?: string | null;
  activBonuses: BonusDTO[] | null;
  totalBonuses: number;
  totalSalary: number;
  lastIncrease: IncreaseDTO;
  totalIncrease: number;
  inactiveBonuses: BonusDTO[] | null;
  netSalaryLastMONTH: number;
  totalBonusesLastMonth: number;
  annual: boolean;
  currency?: string | null;
}

interface ContractVersion2DTO {
  id: number;
  contractId: number;
  type?: string | null;
  effectiveDate: string;
  mutual: boolean;
  hasTrialPeriod: boolean;
  trialPeriodDate?: string | null;
  salaryAmount: number;
  salaryCurrency?: string | null;
  origin: boolean;
  salaryType: 'year' | 'month' | 'week' | 'day' | 'hour' | 'once';
  functionId: number;
  hTravailId?: number | null;
  departementId: number;
  societeId?: number | null;
  hTravaileList: SelectItem[];
  fonctionList: SelectItem[];
  typeList: SelectItem[];
  salaryHistory: SalaryDTO[] | null;
  contractHistory: ContractHistoryDTO | null;
  departementList?: SelectItem[] | null;
  societeList?: SelectItem[] | null;
  showSociety: boolean;
  departureReason?: string | null;
  departureReasonList?: SelectItem[] | null;
  currencyList?: SelectItem[] | null;
}

interface Contract2DTO {
  id: number;
  affectedUserId?: string | null;
  endDate?: string | null;
  version: ContractVersion2DTO;
}

enum Status {
  None = 0,
  Inactive = 1,
  Invited = 2,
  Active = 3,
  Disabled = 4,
  Archived = 5,
}

interface FormValues {
  id?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  username?: string | null;
  email?: string | null;
  status?: Status;
  hiringDate: string;
  soldeInitial?: number | null;
  typeOfContract?: string | null;
  siteId?: number | null;
  areaId?: number | null;
  contracts?: SelectItem[] | null;
  sites?: SelectItem[] | null;
  areas?: SelectItem[] | null;
  functions?: SelectItem[] | null;
  workTimes?: SelectItem[] | null;
  invitation: boolean;
  usePhoneAsLogin: boolean;
  password?: string | null;
  codeClient?: string | null;
  phone1?: string | null;
  phone2?: string | null;
  clientCountry?: string | null;
  codeinvitation?: number | null;
  idClient?: number | null;
  contractDTO: Contract2DTO;
  genre?: string | null;
  lang?: string | null;
  superior?: SelectItem[] | null;
  superiorId?: string | null;
  genderList?: SelectItem[] | null;
  listregime?: SelectItem[] | null;
  listServices?: SelectItem[] | null;
  regimeId?: number | null;
  serviceId?: number | null;
}

export type { FormValues, options };
